import { useEffect, useState } from "react";
import axios from "axios";
import "../css/trackOrder.css";
import {
  FaBox,
  FaShippingFast,
  FaTruck,
  FaCheckCircle
} from "react-icons/fa";

function TrackOrder() {

  const [orders, setOrders] = useState([]);

  const userId = localStorage.getItem("user_id");

  useEffect(() => {

    if (!userId) return;

    axios
      .get(`http://localhost:5000/api/track-order/${userId}`)
      .then((res) => {

        setOrders(res.data);

      })
      .catch((err) => {

        console.log(err);

      });

  }, [userId]);

  return (

    <div className="track-page">

      <section className="track-hero">

        <div className="track-overlay">

          <h1>Track Your Orders</h1>

          <p>
            View the latest status of your orders.
          </p>

        </div>

      </section>

      <section className="track-section">

        <div className="track-container">

          {
            orders.length === 0 ?

            <h2>No Orders Found</h2>

            :

            orders.map((order) => (

              <div className="track-card" key={order.id}>

                <h2>Order #{order.id}</h2>

                <p>
                  <strong>Total:</strong> ${order.total}
                </p>

                <p>
                  <strong>Payment:</strong> {order.payment_status}
                </p>

                <p>
                  <strong>Status:</strong> {order.order_status}
                </p>

                <p>
                  <strong>Date:</strong>{" "}
                  {new Date(order.created_at).toLocaleString()}
                </p>

                <div className="status-grid">

                  <div className={`status-card ${
                    ["Pending","Processing","Shipped","Delivered"].includes(order.order_status)
                      ? "active"
                      : ""
                  }`}>
                    <FaBox className="status-icon"/>
                    <h4>Order Placed</h4>
                  </div>

                  <div className={`status-card ${
                    ["Processing","Shipped","Delivered"].includes(order.order_status)
                      ? "active"
                      : ""
                  }`}>
                    <FaShippingFast className="status-icon"/>
                    <h4>Processing</h4>
                  </div>

                  <div className={`status-card ${
                    ["Shipped","Delivered"].includes(order.order_status)
                      ? "active"
                      : ""
                  }`}>
                    <FaTruck className="status-icon"/>
                    <h4>Shipped</h4>
                  </div>

                  <div className={`status-card ${
                    order.order_status === "Delivered"
                      ? "active"
                      : ""
                  }`}>
                    <FaCheckCircle className="status-icon"/>
                    <h4>Delivered</h4>
                  </div>

                </div>

              </div>

            ))
          }

        </div>

      </section>

    </div>

  );

}

export default TrackOrder;